import { render, staticRenderFns } from "./RegistrationDetail.vue?vue&type=template&id=2e2711c6&scoped=true&"
import script from "./RegistrationDetail.vue?vue&type=script&lang=js&"
export * from "./RegistrationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2711c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/usr/src/regapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSheet } from 'vuetify/lib'
installComponents(component, {VDivider,VFlex,VLayout,VSheet})
